// removed by extract-text-webpack-plugin
module.exports = {"root":"_2YLXo","subTitle":"_1BRBB","statements":"__UcFD","statement":"_312dY","icon":"_2gnQW","left":"_1eyCo","right":"_3Eqtn"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/SecurePaymentStatement/SecurePaymentStatement.scss
// module id = 1353
// module chunks = 3